import { render, staticRenderFns } from "./ASedes-programas.vue?vue&type=template&id=5ba0dce9"
import script from "./ASedes-programas.vue?vue&type=script&lang=js"
export * from "./ASedes-programas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports